import React from "react";
import {
  useHasDentitionPermission,
  useHasSaleyardOrDeploymentPermission,
} from "hooks";
import {
  DeploymentPermission,
  SaleyardPermission,
} from "constants/permissions";
import { MLAMissingFieldsIndicator } from "./MlaMissingFieldsIndicator";
import { NASMissingFieldsIndicator } from "./NasMissingFieldsIndicator";
import { CombinedMissingFieldIndicatorProps } from "./types";

export const CombinedMissingFieldIndicator: React.FC<
  CombinedMissingFieldIndicatorProps
> = ({ modelIds, onlyAdvancedFields = false }) => {
  // Check if NAS indicators will be shown (Nutrien users)
  const hasDentitionPermission = useHasDentitionPermission();
  const hasWeightRangePermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermission.featureWeightRange,
    SaleyardPermission.featureWeightRange,
  );

  const showNASIndicator =
    !onlyAdvancedFields && hasDentitionPermission && hasWeightRangePermission;

  return (
    <>
      <NASMissingFieldsIndicator
        keyValue={modelIds}
        onlyAdvancedFields={onlyAdvancedFields}
      />
      {/* Only show MLA/Data indicator if NAS indicator is not being shown */}
      {!showNASIndicator && <MLAMissingFieldsIndicator keyValue={modelIds} />}
    </>
  );
};
